import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters} from 'src/modules/entitlements/typedef';

export const assignAccountEntitlementsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    EntitlementsFilters
>('assignAccountEntitlementsState', undefined);

export const assignAccountEntitlementsStateActions = assignAccountEntitlementsStateSlice.actions;
export const assignAccountEntitlementsStateSelector:
CachedTableStateSelector<undefined, undefined, EntitlementsFilters>
    = state => state.accountPage.assignEntitlements.state;
